import { render, staticRenderFns } from "./SideIcon.vue?vue&type=template&id=83a4e960&scoped=true&lang=pug&"
import script from "./SideIcon.vue?vue&type=script&lang=js&"
export * from "./SideIcon.vue?vue&type=script&lang=js&"
import style0 from "./SideIcon.vue?vue&type=style&index=0&id=83a4e960&prod&lang=sass&"
import style1 from "./SideIcon.vue?vue&type=style&index=1&id=83a4e960&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a4e960",
  null
  
)

export default component.exports